module.exports = __webpack_public_path__ + "static/img/thesis_thumbnail.e90ad9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/thesis_thumbnail.jpg
// module id = NAW6
// module chunks = 9